import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';

import { Observable, of, throwError } from 'rxjs';
import { catchError } from 'rxjs/operators';

import { EntryPoint, EntryPointService, LocalStorageService, ReportService } from '@mirage-projects/cw-commons';
import { CompanyReport, Report, UserReport } from '@mirage-projects/cw-models';

@Injectable({
    providedIn: 'root',
})
export class AppReportService implements ReportService {
    constructor(
        private http: HttpClient,
        private entryPointService: EntryPointService,
        private localStorageService: LocalStorageService
    ) {}

    /**
     * Get the report
     */
    get(): Observable<Report> {
        const url = this.entryPointService.getResource(EntryPoint.REPORT);
        return this.http.get<Report>(`${url}`).pipe(catchError((err: any) => throwError(err)));
    }

    /**
     * Get the report by scope and user id
     * @param scope Scope
     * @param userId User id
     */
    getByScopeAndUserId(scope: string, userId: string): Observable<Report> {
        const entrypointReportAddress = this.entryPointService.getResource(EntryPoint.REPORT);
        if (!entrypointReportAddress) {
            return of<Report>({
                site: {
                    storageSize: 0,
                } as UserReport,
                company: {
                    storageSize: 0,
                } as CompanyReport,
                licences: {
                    maxstorage: 1000000000000,
                    maxprocessing: 1000000000000,
                    maxtransfer: 1000000000000,
                },
            });
        }

        const url = `${entrypointReportAddress}?scope=${scope}&user=${userId}`;
        return this.http.get<Report>(`${url}`).pipe(catchError((err: any) => throwError(err)));
    }
}
